// extracted by mini-css-extract-plugin
module.exports = {"pageHeader":"CreditEvalution_pageHeader__3kKhR","TabPanelSection":"CreditEvalution_TabPanelSection__2kK5v"};